import { useEffect, useRef, useState } from 'react'
import IconInput from './IconInput'
import { IoMdSearch } from 'react-icons/io'
import { IoClose } from 'react-icons/io5'
import { useDebouncedCallback } from 'use-debounce'
import { useNavigate, useSearchParams } from 'react-router-dom'

const SearchInput = () => {
  const input = useRef<HTMLInputElement>(null)
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const [searchInput, setSearchInput] = useState(searchParams.get('q') || '')

  const setSearchQuery = useDebouncedCallback((query: string) => {
    query ? setSearchParams({ q: query }) : setSearchParams('')
  }, 500)

  const onClose = () => {
    navigate('..', { relative: 'path' })
  }

  useEffect(() => {
    if (input.current) {
      input.current.focus()
    }
  }, [input])

  return (
    <div>
      <IconInput
        ref={input}
        leftIcon={<IoMdSearch size={24} color="#000" />}
        rightIcon={
          <IoClose
            size={24}
            color="#000"
            className={'cursor-pointer'}
            onClick={onClose}
          />
        }
        onChange={(e) => {
          setSearchInput(e.target.value)
          setSearchQuery(e.target.value)
        }}
        value={searchInput}
      />
    </div>
  )
}

export default SearchInput
